export interface IDisplayMetrics {
    screen: { width: number; height: number; } // height * devicePixelRatio can still be off by a few due to rounding
    viewport: { width: number; height: number; }
    devicePixelRatio: number;
    statusBarHeight?: number;
    navigationBarHeight?: number;
}

export interface IStatusBarHeightProvider {
    getHeight: () => number;
    getNavigationBarHeight: () => number;
}

export class StatusBarHeightProviderPlaceholder implements IStatusBarHeightProvider  {
    constructor(){
        throw new Error('ioc HeightProviderPlaceholder should have been swapped out for DeviceStatusBar');
    }
    getHeight = () => {
        throw new Error('not implemented');
    };
    getNavigationBarHeight = () => {
        throw new Error('not implemented');
    };
}

/**
 * We may find we want to do some caching, but I expect we don't use this method enough to warrant that.
 * I didn't cache because we want this metrics to uncover bad assumptions. Eg our app is made smaller
 * by another app and os feature, we don't want to send the wrong metric (by computing only at parse  or app start time);
 */
export class DisplayMetricsProvider {

    static inject = () => [StatusBarHeightProviderPlaceholder];
    constructor(private statusBar: StatusBarHeightProviderPlaceholder){}

    getMetrics = (): IDisplayMetrics => {

        let statusBarHeight: number | undefined;
        let navigationBarHeight: number | undefined;
        try {
            statusBarHeight = this.statusBar.getHeight();
            navigationBarHeight = this.statusBar.getNavigationBarHeight();
        } catch {
            // this fails if DeviceStatusBar hasn't been initialized yet,
            // in this case just leave the values undefined
        }

        return {
            screen: {
                width: window.screen.width,
                height: window.screen.height,
            },
            viewport: {
                width: window.innerWidth,
                height: window.innerHeight
            },
            devicePixelRatio: window.devicePixelRatio,
            statusBarHeight,
            navigationBarHeight
        };
    };

}
